//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      playTime: 3 * 60, // 试玩时间 3 minutes in seconds
      countDown: null,
      show: false,
    };
  },
  computed: {
    url() {
      return this.$route.query.url;
    },
  },
  methods: {
    setCountDown() {
      this.countDown = setInterval(() => {
        this.playTime--;
        if (this.playTime < 0) {
          this.show = true;
          clearInterval(this.countDown);
        }
      }, 1000);
    },
  },
  activated() {
    this.setCountDown();
  },
  deactivated() {
    this.playTime = 3 * 60; // Reset play time
    clearInterval(this.countDown);
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/guestPlay/index.vue